import React from "react";

const Proceso = () => {
    return <div>Proceso</div>;
};

export default Proceso;
